import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  DialogActions,
  Button,
} from "@mui/material";
import { checkEmail } from "../../../../../components/inputs/email/emailInput";
import EditCoachProps from "../../interface/editCoachProps";
import React from "react";
import RenderFirstNameInput from "./src/renderFirstNameInput";
import RenderLastNameInput from "./src/renderLastNameInput";
import RenderEmailInput from "./src/renderEmailInput";
import RenderTeamsLinkInput from "./src/renderTeamsLinkInput";
import RenderStatusInput from "./src/renderStatusInput";
import { CoachListContext } from "../../context/coachListContext";
import CoachProps from "../../interface/coachProps";

const EditCoachDialog = (): React.JSX.Element => {
  const {
    setEditCoach,
    editCoach,
    doEdit,
  }: {
    setEditCoach: (editCoach: {
      showDialog: boolean;
      coach: CoachProps;
    }) => void;
    editCoach: EditCoachProps;
    doEdit: () => void;
  } = React.useContext(CoachListContext);

  return (
    <Dialog
      maxWidth="lg"
      open={editCoach.showDialog}
      onClose={() =>
        setEditCoach({
          ...editCoach,
          showDialog: false,
        })
      }
      aria-labelledby="edit-coach-alert-dialog-title"
      aria-describedby="edit-coach-alert-dialog-description"
    >
      <DialogTitle id="edit-coach-alert-dialog-title">
        Coach bearbeiten
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RenderFirstNameInput />
          </Grid>

          <Grid item xs={12} md={6}>
            <RenderLastNameInput />
          </Grid>

          <Grid item xs={12}>
            <RenderEmailInput />
          </Grid>

          <Grid item xs={12}>
            <RenderTeamsLinkInput />
          </Grid>

          <Grid item xs={12}>
            <RenderStatusInput />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: 2,
        }}
      >
        <Button
          onClick={() =>
            setEditCoach({
              ...editCoach,
              showDialog: false,
            })
          }
          variant="outlined"
          color="secondary"
        >
          Schließen
        </Button>

        <Button
          onClick={doEdit}
          variant="contained"
          color="primary"
          disabled={
            editCoach.coach.vorname.length === 0 ||
            editCoach.coach.nachname.length === 0 ||
            !checkEmail(editCoach.coach.email) ||
            editCoach.coach.teams_link.length === 0
          }
        >
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCoachDialog;
